import { render, staticRenderFns } from "./ParkingSpaceNewxg.vue?vue&type=template&id=5332be46&"
import script from "./ParkingSpaceNewxg.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceNewxg.vue?vue&type=script&lang=js&"
import style0 from "./ParkingSpaceNewxg.vue?vue&type=style&index=0&id=5332be46&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5332be46')) {
      api.createRecord('5332be46', component.options)
    } else {
      api.reload('5332be46', component.options)
    }
    module.hot.accept("./ParkingSpaceNewxg.vue?vue&type=template&id=5332be46&", function () {
      api.rerender('5332be46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/parking-space/ParkingSpaceNewxg.vue"
export default component.exports